<template>
    <div>
        <b-row v-if="!current_customer.cjp_id">
            <b-col cols="12" v-loading="is_loading_solution">
                <div class="card-table">
                    <div class="d-flex justify-content-between mb-2">
                        <el-button
                            type="danger"
                            @click="resetCTOSReport"
                            :loading="is_loading_solution"
                            size="mini"
                            icon="el-icon-refresh-left"
                            v-if="(!_gHlp.isEmpty(current_commitment) && (current_commitment.credit_report_platform != 'MANUAL')) && !_gAuth.isAppDahongye()"
                        >
                            {{ _gAuth.isAppSas() ? 'Refresh CTOS' : 'Refresh Latest Data' }}
                        </el-button>
                        <el-button type="info" @click="modals.show_full_view = true" size="mini" icon="el-icon-refresh-left" >Full View Loan Information</el-button>
                     </div>
										<el-collapse v-model="activeNames" class="border-0">
												<el-collapse-item name="1" class="my-3">
													<div slot="title" class="collapse-header px-3">
														<h3 class="mb-0">Loan Information</h3>
													</div>	
													<CommitmentScenario :tables="tables" :isfull="false"/>
												</el-collapse-item>	
												<el-collapse-item name="2" class="my-3" v-if="isGovernment">
													<div slot="title" class="collapse-header px-3">
														<h3 class="mb-0">Payslip Deduction</h3>
													</div>	
													<PayslipSolution :tables="tables"/>
												</el-collapse-item>	
												<el-collapse-item name="3" class="my-3">
													<div slot="title" class="collapse-header px-3">
														<h3 class="mb-0">Angkasa | <small>Last Prescreening Analysis : {{ lastCreditReportPullDate }}</small></h3>
													</div>	
													<Angkasa :tables="tables"/>
												</el-collapse-item>	
												<el-collapse-item name="4" class="my-3">
													<div slot="title" class="collapse-header px-3">
														<h3 class="mb-0">Trade Reference</h3>
													</div>	
													<TradeRef :tables="tables"/>
												</el-collapse-item>	
												<el-collapse-item name="5" class="my-3">
													<div slot="title" class="collapse-header px-3">
														<h3 class="mb-0">Special Attention Account</h3>
													</div>	
													<SpecialAttention :tables="tables"/>
												</el-collapse-item>	
										</el-collapse>
                </div>
            </b-col>
        </b-row>
        <b-row class="bg-secondary position-relative" :class="!current_customer.cjp_id ? 'mt-5': ''">
            <b-col>
                <h4 class="py-4">Select one product</h4>
            </b-col>
            <b-col cols="12" class="solution-products">
                <b-row class="d-flex align-items-center justify-content-center">
                    <b-col md="auto" cols="6" v-for="status in productKinds" :key="status.id">
                        <b-card
                            :class="{ 
                                'card-selected': status.selected, '': true,
                                'd-none': status.is_not_applicable || status.is_coming_soon, '':true
                            }"
                            @click="selectProductKind(status)"
                        >
                            <div class="under-development rounded" v-if="status.is_coming_soon || status.is_not_applicable">
                                <h3 class="text-white text-center">
                                    <span v-if="!status.is_not_applicable">Coming <br>Soon</span>
                                    <span v-else>Not <br> Applicable</span>
                                </h3>
                            </div>
                            <div class="d-flex align-items-center">
                                <b-icon :icon="status.icon" class="mr-2"></b-icon>
                                <h5 class="mb-1">{{status.label}}</h5>
                            </div>
                            <h5 class="mb-0 font-weight-bold text-danger" v-if="status.loan_amount === 'Not Eligible'">Not Eligible</h5>
                            <div v-else>
                                <small>Loan Amt.</small>
                                <h5 class="mb-0" v-if="status.loan_amount === 'N/A'">N/A</h5>
                                <h5 class="mb-0" v-else>{{ formatCurrencyCard(status.loan_amount) }}</h5>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12">
                <b-row class="d-flex justify-content-center mb-5 mt-4">
                    <b-col cols="6" md="3">
                        <b-button block variant="primary" @click="next" :disabled="isNextButtonDisabled">Next</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <CalculateSolutionScenarioModal :show_full_view.sync="modals.show_full_view" :tables="tables"/>
        <RefinancingInputModal :refinancing_input.sync="modals.refinancing_input" />
    </div>
</template>
<script>
import { Button, Collapse, CollapseItem, Table, TableColumn, Input, Select, Option } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useProductStore } from '@/stores/productStore'
import { useAuthStore } from '@/stores/authStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
		swal
} from '@/assets/js/httpImports.js'
import {isEqual} from 'lodash'
import CommitmentScenario from './Partials/CommitmentScenario.vue'
import CalculateSolutionScenarioModal from './Modals/CalculateSolutionScenarioModal.vue'
import RefinancingInputModal from './Modals/RefinancingInputModal'
import TradeRef from './Partials/TradeRef.vue'
import SpecialAttention from './Partials/SpecialAttention.vue'
import Angkasa from './Partials/Angkasa.vue'
import PayslipSolution from './Partials/PayslipSolution.vue'

export default {
    props: ['commitments', 'tables', 'product_details'],
    components: {
        PayslipSolution,
        Angkasa,
        TradeRef,
        SpecialAttention,
        CalculateSolutionScenarioModal,
        CommitmentScenario,
        RefinancingInputModal,
        [Button.name]: Button,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    mixins: [helperFunctionMixin, notifyFunctionMixin],
    data() {
        return {
            modals:{
                show_full_view: false,
                refinancing_input: false
            },
            tableData: [],
            form: {
                productKind: [],
            },
            productKinds: [],
            original_ctos_commitments:[],
            is_loading_solution: false,
            activeNames:['1']
        }
    },
    computed:{
         ...mapState(useCustomerStore, ['current_customer','current_eligibility', 'current_commitment', 'current_eligibility_pl']),
         ...mapState(useProductStore, ['current_product_type']),
         ...mapState(useAuthStore, ['auth_user']),

        isNextButtonDisabled() {
            return !this.productKinds.some(product => product.selected)
        },
        isGovernment(){
            return (!_gHlp.isEmpty(this.current_customer) && !_gHlp.isEmpty(this.current_customer.incomes) && (this.current_customer.incomes.main.income_type_id == 3 || this.current_customer.incomes.main.income_type_id == 5));
        },
        lastCreditReportPullDate(){
            return (!_gHlp.isEmpty(this.current_commitment)) ? _gHlp.formatDate(this.current_commitment.credit_report_response_datetime, 'Y-m-d') : "No Purchased";
        }
    },
    mounted() {
        solutionEventBus.$on('reset-select-product', this.resetSelectProduct)
        solutionEventBus.$on('refresh-ctos', this.refreshCTOSReport)
    },
    beforeUnmount() {
        solutionEventBus.$off('reset-select-product', this.resetSelectProduct)
        solutionEventBus.$off('refresh-ctos', this.refreshCTOSReport)
    },
    watch: {
        current_eligibility: {
            handler(newVal){
                this.productKinds = [
                    {
                        id: 'Property',
                        label: 'Property',
                        value: 'property',
                        icon: 'building',
                        loan_amount: newVal.max_eligibility,
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_property,
                    },
                    {
                        id: 'Mortgage',
                        label: 'Mortgage',
                        value: 'mortgage',
                        icon: 'house-door',
                        loan_amount: newVal.max_eligibility,
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mortgage,
                    },
                    {
                        id: 'Personal Loan',
                        label: 'Personal Loan',
                        value: 'personal_loan',
                        icon: 'credit-card',
                        loan_amount: !_gHlp.checkAccess(['c_customer__personal_loan_eligible']) ? 'N/A' : this.current_eligibility_pl.max_eligibility,
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_personal_loan,
                    },
                    {
                        id: 'Insurance',
                        label: 'Insurance',
                        value: 'insurance',
                        icon: 'shield-plus',
                        loan_amount: 'N/A',
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_insurance,
                    },
                    {
                        id: 'Refinance',
                        label: 'Refinance',
                        value: 'refinance',
                        icon: 'wallet2',
                        loan_amount: 'N/A',
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_refinance,
                    },
                    {
                        id: 'Solicitor',
                        label: 'Solicitor',
                        value: 'solicitor',
                        icon:  'people',
                        loan_amount: 'N/A',
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_solicitor,
                    },
                    {
                        id: 'Other Cases',
                        label: 'Other Cases',
                        value: 'other',
                        icon: 'grid-fill',
                        loan_amount: 'N/A',
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_other_loan,
                    },
                    {
                        id: 'MHLV',
                        label: 'MHLV',
                        value: 'mhlv',
                        icon: 'grid-fill',
                        loan_amount: 'N/A',
                        selected: false,
                        is_coming_soon: false,
                        is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mhlv,
                    },
                ]
            },
            immediate: true,
        },
        current_customer(newVal){
            if(newVal){
                useProductStore().$patch((state) => {
                    state.current_product_data = { ...state.current_product_data, current_customer: newVal }
                })
            }
        }
    },
    async created(){
        // this.setTable()
        this.getCustomerProducts(this.$route.params.customer_id)
    },
    methods: {
        ...mapActions(useProductStore, ['getCustomerProducts']),
        ...mapActions(useCustomerStore, ['getCommitment', 'generateDSR']),
        async refreshCTOSReport(){
            this.is_loading_solution = true
            await this.generateDSR();
            this.is_loading_solution = false
        },
        resetCTOSReport(){
            swal.fire({
                title: 'Are you sure?',
                text: "You agree to refresh all data back to original ctos !",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, Proceed !'
            }).then( async (result) => {
                if (result.isConfirmed) {
                    this.is_loading_solution = true
                    await this.getCommitment(true)
                    this.is_loading_solution = false
                    this.notifySuccess('<b>CTOS - Successfully Reset.')
                }		
            })
        },
        next(){
            this.productKinds.forEach(product => {
                if (product.selected) {
                    if (product.id === 'Property') {
                        solutionEventBus.$emit('show-property-selections')
                    } else if (product.id === 'Personal Loan') {
                        solutionEventBus.$emit('show-personal-loan-bank')
                    } else if (product.id === 'Mortgage') {
                        solutionEventBus.$emit('show-mortgage-bank')
                    } else if (product.id === 'Insurance') {
                        solutionEventBus.$emit('show-insurance-selection')
                    } else if (product.id === 'Refinance') {
                        this.modals.refinancing_input = true
                        useProductStore().$patch({
                            submit_refinance: false
                        })
                    } else if (product.id === 'Other Cases') {
                        solutionEventBus.$emit('show-otherloan-solution-step')
                        solutionEventBus.$emit('show-otherloan-selection')
                      }else if (product.id === 'Solicitor') {
                        solutionEventBus.$emit('show-solicitor-selection')
                      }else if (product.id === 'MHLV') {
                        solutionEventBus.$emit('show-mhlv-selection')
                    }

                    useProductStore().$patch({
                        current_product_type: product.value,
                        current_product_data: {
                            current_customer: this.current_customer,
                        } 
                    })
                }
            })
        },
        resetSelectProduct() {
            this.productKinds.forEach(product => {
                product.selected = false
                this.form.productKind = null
            })
        },
        selectProductKind(selectedItem) {
            if(!selectedItem.is_coming_soon && !selectedItem.is_not_applicable){
                this.productKinds.forEach((item) => {
                    item.selected = false
                })
                if(selectedItem === this.form.productKind){
                    selectedItem.selected = false
                    this.form.productKind = null
                }else{
                    selectedItem.selected = true
                    this.form.productKind = selectedItem
                }
            }
        },
        formatCurrencyCard(value) {
            return `MYR ${parseFloat(value).toLocaleString(undefined, {minimumFractionDigits: 2})}`;
        },
    }
}
</script>